// eslint-disable-next-line no-undef
require('cleave.js/dist/addons/cleave-phone.ru');
import Cleave from 'cleave.js';

document.addEventListener('DOMContentLoaded', () => {
  /* eslint no-undef: "error"*/
  // eslint-disable-next-line no-new
  let notifyPhones = document.querySelectorAll('[name="notify_phone"]');
  let mobilPhones = document.querySelectorAll('[name="mobil_phone"]');

  const notifyPhonesArray = Array.from(notifyPhones);
  const mobilPhonesArray = Array.from(mobilPhones);

  const phones = notifyPhonesArray.concat(mobilPhonesArray);

  phones.forEach(elem => {
    // eslint-disable-next-line no-new
    new Cleave(elem, {
      phone: true,
      phoneRegionCode: 'ru'
    });
  });
});
